import { render, staticRenderFns } from "./DetectionsEditor.vue?vue&type=template&id=90ead45a&scoped=true&"
import script from "./DetectionsEditor.vue?vue&type=script&lang=js&"
export * from "./DetectionsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ead45a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90ead45a')) {
      api.createRecord('90ead45a', component.options)
    } else {
      api.reload('90ead45a', component.options)
    }
    module.hot.accept("./DetectionsEditor.vue?vue&type=template&id=90ead45a&scoped=true&", function () {
      api.rerender('90ead45a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InsectDetectionsEditor/DetectionsEditor/DetectionsEditor.vue"
export default component.exports